import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'dome-spinner',
  templateUrl: './spinner.component.html',
})
export class SpinnerComponent {}
